import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { map, Observable } from 'rxjs';
import { base64ToGuid, guidToBase64 } from '@core/utils/guid-encode';
import { AsyncPipe } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-guid-decode',
  templateUrl: './guid-decode.component.html',
  styleUrls: ['./guid-decode.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    AsyncPipe,
  ],
})
export class GuidDecodeComponent {
  valueControl: FormControl = new FormControl();
  guidValue$: Observable<string> = this.valueControl.valueChanges.pipe(
    map((value: string) => {
      try {
        return base64ToGuid(value);
      } catch (e) {
        return e.message;
      }
    })
  );
  base64Value$: Observable<string> = this.valueControl.valueChanges.pipe(
    map((value: string) => {
      try {
        return guidToBase64(value);
      } catch (e) {
        return e.message;
      }
    })
  );
}
